/**
 * 分享落地页的密码输入卡片（参考 EcommerceReplicate 视觉语言）
 */

import { useState } from 'react';
import { Lock, Loader2 } from 'lucide-react';

interface Props {
  onSubmit: (password: string) => Promise<void>;
  error?: string | null;
}

export function SharePasswordPrompt({ onSubmit, error }: Props) {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!password) return;
    setLoading(true);
    try {
      await onSubmit(password);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="mx-auto w-full max-w-md rounded-[28px] border border-white/70 bg-white/90 p-8 shadow-[0_24px_80px_rgba(15,23,42,0.08)] backdrop-blur-xl"
    >
      <div className="mb-6 flex flex-col items-center gap-3">
        <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-sky-500 to-cyan-400 text-white shadow-lg shadow-sky-200/70">
          <Lock className="h-6 w-6" />
        </div>
        <h2 className="text-lg font-semibold text-slate-900">需要密码访问</h2>
        <p className="text-sm text-slate-500">请输入分享者设置的访问密码</p>
      </div>

      <input
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="4-6 位数字密码"
        maxLength={6}
        pattern="\d{4,6}"
        autoFocus
        className="mb-3 w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-center text-lg tracking-widest text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-sky-300 focus:ring-2 focus:ring-sky-100"
      />

      {error && (
        <div className="mb-3 rounded-2xl border border-rose-100 bg-rose-50 px-4 py-2.5 text-center text-sm text-rose-600">
          {error}
        </div>
      )}

      <button
        type="submit"
        disabled={loading || password.length < 4}
        className="inline-flex w-full items-center justify-center gap-2 rounded-2xl bg-slate-950 px-5 py-2.5 text-sm font-semibold text-white shadow-lg shadow-slate-300/70 transition hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-50"
      >
        {loading && <Loader2 className="h-4 w-4 animate-spin" />}
        访问视频
      </button>
    </form>
  );
}
